import React, { ReactElement } from 'react';
import { gql } from 'apollo-boost';
import { useQuery } from '@apollo/react-hooks';
import { Box, Text } from '@chakra-ui/core';
import { ReportInfoBlock } from 'typings';
import DataBookYearDownloads from './DataBookYearDownloads';

/** Used by Superintendent's Annual Report (`annual-report`). HIDOE Data Book uses the parent page layout instead. */
const REPORT_INFO_BLOCK_QUERY = gql`
  query getReport($slug: String!, $year: Int!) {
    getReport(slug: $slug) {
      id
      infoBlocks(year: $year) {
        id
        title
        text
      }
    }
  }
`;

interface Props {
  year: number;
  slug: string;
}

const DataBookInfoBlock: React.FC<Props> = ({ year, slug }): ReactElement => {
  const { data } = useQuery(REPORT_INFO_BLOCK_QUERY, {
    variables: { slug, year },
  });

  let infoBlocks: any;
  let published: any;
  if (data) {
    infoBlocks = data.getReport.infoBlocks.filter((i: ReportInfoBlock) => {
      if (i.title.toLowerCase() === 'published') {
        published = i;
        return false;
      }
      return true;
    });
  }

  return (
    <Box padding="40px" paddingTop="24px">
      <Text fontSize="36px" fontWeight="bold" color="black" marginBottom="16px">
        School Year: {`${year - 1} - ${year}`}
      </Text>
      {published && (
        <Text fontSize="16px" color="gray.800" marginBottom="16px">
          Published {published.text}
        </Text>
      )}
      <Text fontSize="20px" fontWeight="bold" marginBottom="24px">
        {year} - Selected Highlights
      </Text>
      {infoBlocks && infoBlocks.length > 0 ? (
        <InfoBlocks blocks={infoBlocks} />
      ) : (
        <Box height="200px" marginTop="32px">
          <Text>No Information Found for that Year. </Text>
        </Box>
      )}
      <DataBookYearDownloads year={year} slug={slug} />
    </Box>
  );
};

const InfoBlocks: React.FC<{ blocks: ReportInfoBlock[] }> = ({ blocks }): ReactElement => {
  return (
    <>
      {blocks.map(block => (
        <Box key={block.id}>
          <Text fontSize="16px" fontWeight="bold" marginBottom="8px">
            {block.title}:
          </Text>
          <Text fontSize="16px" color="gray.900" marginBottom="16px">
            {block.text}
          </Text>
        </Box>
      ))}
    </>
  );
};

export default DataBookInfoBlock;
